import { MapContainer, TileLayer, Circle, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const CENTER = [49.1247, -1.4764];

const TOWNS = [
  { name: "Muneville-le-Bingard", pos: CENTER, main: true },
  { name: "Coutances", pos: [49.0452, -1.4449] },
  { name: "Saint-Lô", pos: [49.1167, -1.0833] },
  { name: "Granville", pos: [48.8379, -1.5971] },
  { name: "Portbail-sur-Mer", pos: [49.3353, -1.6978] },
];

const dotIcon = (main) =>
  L.divIcon({
    className: "",
    html: `<span style="display:block;width:${main ? 18 : 12}px;height:${main ? 18 : 12}px;border-radius:9999px;background:${main ? "#C85A32" : "#3D5A45"};border:3px solid #FDFBF7;box-shadow:0 2px 8px rgba(43,58,48,.4)"></span>`,
    iconSize: [main ? 18 : 12, main ? 18 : 12],
    iconAnchor: [main ? 9 : 6, main ? 9 : 6],
  });

export default function ZoneMap() {
  return (
    <div className="relative" data-testid="zone-map-block">
      <div className="overflow-hidden rounded-[1.75rem] border border-stone-border shadow-[0_30px_60px_-30px_rgba(43,58,48,0.45)]">
        <MapContainer
          center={CENTER}
          zoom={9}
          scrollWheelZoom={false}
          className="relative z-0 h-[380px] w-full md:h-[440px]"
          data-testid="zone-map-interactive"
        >
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution="&copy; OpenStreetMap contributors"
          />
          <Circle
            center={CENTER}
            radius={30000}
            pathOptions={{ color: "#C85A32", weight: 2.5, fillColor: "#C85A32", fillOpacity: 0.07 }}
          />
          {TOWNS.map((t) => (
            <Marker key={t.name} position={t.pos} icon={dotIcon(t.main)}>
              <Popup>{t.name}</Popup>
            </Marker>
          ))}
        </MapContainer>
      </div>

      <div className="absolute -bottom-5 left-6 whitespace-nowrap rounded-full border border-stone-border bg-cream/95 px-5 py-2.5 shadow-lg backdrop-blur-md" data-testid="zone-map-caption">
        <span className="font-serif text-sm italic text-ink">Un rayon d'environ 30 km autour de Muneville-le-Bingard</span>
      </div>
    </div>
  );
}
